import { __assign, __spreadArray } from "tslib";
import { breakpoints as breakpointsFromTokens } from '@metro-ui/tokens/js';
import { getKeys } from '../getKeys';
import { isReponsiveObject, } from './responsiveProp';
export var sortedBreakpointsArray = Object.entries(__assign({ xs: 0 }, breakpointsFromTokens)).sort(function (a, b) { return a[1] - b[1]; });
export var sortedBreakpointsObject = Object.fromEntries(sortedBreakpointsArray);
export var sortedBreakpointsKeys = getKeys(sortedBreakpointsObject);
export var getBreakpointByWidth = function (allowedBreakpoints, clientWidth) {
    if (!allowedBreakpoints || !allowedBreakpoints.length)
        return undefined;
    var firstBreakpoint = allowedBreakpoints[0];
    var entry = __spreadArray([], allowedBreakpoints).reverse()
        .find(function (breakpoint) { return sortedBreakpointsObject[breakpoint] <= clientWidth; });
    return entry !== null && entry !== void 0 ? entry : firstBreakpoint;
};
export var getCurrentGlobalBreakpoint = function () {
    return getBreakpointByWidth(sortedBreakpointsKeys, document.documentElement.clientWidth);
};
var getBreakpointByBreakpoint = function (allowedBreakpoints, breakpoint) {
    if (!allowedBreakpoints || !allowedBreakpoints.length)
        return undefined;
    var firstBreakpoint = allowedBreakpoints[0];
    var sortedAllowedBreakpoints = __spreadArray([], sortedBreakpointsArray).filter(function (_a) {
        var key = _a[0];
        return allowedBreakpoints.includes(key);
    });
    var entry = __spreadArray([], sortedAllowedBreakpoints).reverse()
        .find(function (_a) {
        var key = _a[0];
        return sortedBreakpointsObject[breakpoint] >= sortedBreakpointsObject[key];
    });
    return entry ? entry[0] : firstBreakpoint;
};
export var resolveResponsiveProp = function (responsiveProp, breakpoint) {
    if (!isReponsiveObject(responsiveProp))
        return responsiveProp;
    var responsiveObject = responsiveProp;
    var definedBreakpoint = getBreakpointByBreakpoint(getKeys(responsiveObject), breakpoint);
    return responsiveObject[definedBreakpoint];
};
export var hasBreakpointChanged = function (relevantBreakpoints, newValue, oldValue) {
    return getBreakpointByWidth(relevantBreakpoints, newValue) !==
        getBreakpointByWidth(relevantBreakpoints, oldValue);
};
export var getBreakpointsOfProps = function () {
    var props = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        props[_i] = arguments[_i];
    }
    var responsiveObjects = props.filter(function (i) {
        return isReponsiveObject(i);
    });
    var defaultBreakpoints = __spreadArray(['xs'], sortedBreakpointsKeys);
    var allKeys = responsiveObjects.flatMap(function (obj) { return getKeys(obj); });
    return defaultBreakpoints.filter(function (breakpoint) { return allKeys.includes(breakpoint); });
};
export var hasBreakpointChangedForProps = function (props, newValue, oldValue) {
    var relevantBreakpoints = getBreakpointsOfProps.apply(void 0, props);
    if (!relevantBreakpoints.length)
        return false;
    return hasBreakpointChanged(relevantBreakpoints, newValue, oldValue);
};
//# sourceMappingURL=responsivePropReact.js.map